import { Tag } from '../../cdl/Tag/Tag';
import { Text } from '../../cdl/Text/Text';
import { Box } from '../../common/ui/Box';
import type { DemandBreakdownProduct } from '../types/DemandBreakdownProduct';

import { DemandLiftingCount } from './DemandLiftingCount';
import { DemandProductName } from './DemandProductName';
import { DemandVolume } from './DemandVolume';
import { ResultingDemandRow } from './ResultingDemandRow';

interface ResultingDemandProductRowProps {
    product: DemandBreakdownProduct;
    showChanges: boolean;
}

export const ResultingDemandProductRow = ({ product, showChanges }: ResultingDemandProductRowProps) => (
    <ResultingDemandRow $showChanges={showChanges}>
        <Box display="flex" flexDirection="column">
            <Box display="flex" alignItems="center" gap={8} minWidth={0}>
                <DemandProductName name={product.productName ?? product.productId} />
                {product.supplierProductGroup ? <Tag>{product.supplierProductGroup}</Tag> : null}
            </Box>
            <DemandLiftingCount count={product.liftingCount} />
        </Box>
        <Text variant="small" color={showChanges ? 'foreground.subtle' : 'foreground.muted'}>
            <DemandVolume volume={product.historicalVolume} />
        </Text>
        {showChanges ? (
            <>
                <Box />
                <Box />
            </>
        ) : null}
    </ResultingDemandRow>
);
